import {Service} from "angular-ecmascript/module-helpers";
import SearchTemplate from "./search.modal.html";

export let Name = 'searchModalDelegate';

export default class SearchModalDelegate extends Service {
    static $name = Name;
    static $inject = ['$q', '$modalDelegate'];

    show(options) {

        this.$modalDelegate.show({
            scope: this.$scope,
            template: SearchTemplate,
            args: {
                showTypeSelection: options.showTypeSelection,
                showTypeSelectionBookings: options.showTypeSelectionBookings,
                showTypeSelectionCustomers: options.showTypeSelectionCustomers,
                showTypeSelectionVehicles: options.showTypeSelectionVehicles,
                showTypeSelectionWheelStorages: options.showTypeSelectionWheelStorages,

                showSearchTerm: options.showSearchTerm,
                searchTerm: options.searchTerm,
                searchType: options.searchType,
                searchWithoutTerm: options.searchWithoutTerm,

                bookingsFilter: options.bookingsFilter,
                customersFilter: options.customersFilter,
                vehiclesFilter: options.vehiclesFilter,
                wheelStoragesFilter: options.wheelStoragesFilter
            },

            onSave: (selection) => {
                if (selection.booking && options.onBookingSelected) {
                    options.onBookingSelected(selection.booking);
                }

                if (selection.customer && options.onCustomerSelected) {
                    options.onCustomerSelected(selection.customer);
                }

                if (selection.vehicle && options.onVehicleSelected) {
                    options.onVehicleSelected(selection.vehicle);
                }

                if (selection.wheelStorage && options.onWheelStorageSelected) {
                    options.onWheelStorageSelected(selection.wheelStorage);
                }

                if (options.onSave) {
                    options.onSave(selection);
                }

                return selection;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/search/search.modal.service.js